const styles = {
  getGridSx: (isLandingPage, inView) => ({
    display: "grid",
    gridTemplateColumns: isLandingPage
      ? { xs: "minmax(0, 340px)", sm: "repeat(2, minmax(0, 320px))", md: "repeat(3, minmax(0, 340px))" }
      : { xs: "minmax(0, 340px)", sm: "repeat(2, minmax(0, 400px))", md: "repeat(3, minmax(0, 340px))" },
    justifyContent: "center",
    "& > *:last-child:nth-child(3n+1)": { gridColumn: { md: "2" } },
    gap: { xs: 2, md: 2 },
    width: "100%",
    opacity: inView ? 1 : 0,
    transform: inView ? "none" : "translateY(28px)",
    transition: "opacity 0.7s ease, transform 0.7s ease",
  }),

  buttonWrapperSx: { width: "100%", display: "flex", justifyContent: "center" },

  buttonSx: {
    px: { xs: 5, md: 8 },
    py: { xs: 1.5, md: 2 },
    fontSize: { xs: 14, md: 16 },
    mt: { xs: 5, md: 8 },
    mb: { xs: 6, md: 10 },
  },

  progressSx: { color: "white" },
};

export default styles;
